import { _ as __rest } from './tslib.es6-b97b9ccd.js';
import React__default from 'react';
import { u as useTranslations } from './index-f8dbf8e4.js';
import { C as CommonGAssets } from './index-2bf5f78a.js';
import { H as HealthToolCardWrapper } from './index-694ed585.js';
import { O as OvulationForm } from './index-15466f63.js';
import './translationsContext-f94ca99c.js';
import './constantsDomainLocales.js';
import './Locale-e37edea6.js';
import './constantsIsProduction.js';
import '@mantine/core';
import '@hhgtech/icons/other';
import './index-ed1b642a.js';
import '@mantine/hooks';
import './useScreenSize-e572cdeb.js';
import '@emotion/styled';
import './utils-1a4cbdae.js';
import '@mantine/carousel';
import './index-5c0e8412.js';
import './other-cef0261a.js';
import './index-57001be3.js';
import './miscTheme.js';
import './useMantineLocale-738fc2b0.js';
import '@mantine/notifications';
import './index-d722456d.js';
import 'date-fns/locale';
import './constantsSite.js';
import './constantsRiskScreener.js';
import 'dayjs';
import './index-966f3431.js';
import 'classnames';
import './useUniqueId-0499a705.js';
import '@hhgtech/icons/core';
import '@mantine/dates';
import './index.styles-2ae2bbf8.js';
import './index-6a7dde31.js';
import './miscDefaultClassWrapper.js';
import '@mantine/form';
import './LastPeriod-58eaee50.js';
import './index-de4ba53a.js';
import './index-c9060602.js';
import 'react-keyed-flatten-children';

const OvulationCardEmbed = (_a) => {
    var _b;
    var { ovulationPageInfo, expertUrl, formProps, isMobile } = _a, props = __rest(_a, ["ovulationPageInfo", "expertUrl", "formProps", "isMobile"]);
    const { t } = useTranslations();
    return (React__default.createElement(HealthToolCardWrapper, Object.assign({ isPregTool: true }, props),
        React__default.createElement(HealthToolCardWrapper.Banner, { icon: React__default.createElement("img", { alt: "health-tool-icon", src: (ovulationPageInfo === null || ovulationPageInfo === void 0 ? void 0 : ovulationPageInfo.featured_image) ||
                    CommonGAssets.getAssetPath('health-tools/ovulation-icon.svg'), loading: "lazy" }), heading: (ovulationPageInfo === null || ovulationPageInfo === void 0 ? void 0 : ovulationPageInfo.title) || t('healthTools.ovulationCalculator'), medicalReview: {
                link: expertUrl,
                reviewer: (_b = ovulationPageInfo === null || ovulationPageInfo === void 0 ? void 0 : ovulationPageInfo.reviewed_by) === null || _b === void 0 ? void 0 : _b.display_name,
                date: ovulationPageInfo === null || ovulationPageInfo === void 0 ? void 0 : ovulationPageInfo.reviewed_date,
            } }),
        React__default.createElement(HealthToolCardWrapper.Body, null,
            React__default.createElement(OvulationForm, Object.assign({ isMobile: isMobile }, formProps)))));
};

export { OvulationCardEmbed };
